import React from 'react';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';

import { Text, Button, Icon } from 'Components/Base';
import { FONT_SIZE, SPACE } from 'Components/Theme';

const Image = styled.img`
  max-height: 20vh;
  @media (min-width: 768px) {
    max-height: none;
  }
`;

const EmptyView = ({ onLinkSchoolClick = () => {}, ...props }) => (
  <Flex flexDirection={'column'} alignItems={'center'}>
    <Box mb={SPACE.medium} style={{ textAlign: 'center' }}>
      <Image src="/images/redeem_empty.svg" />
    </Box>

    <Text
      color="greyscale.grey2" // fontSize={FONT_SIZE.medium}
      mb={SPACE.medium}
      textAlign="center"
      mt={SPACE.small}
    >
      ยังไม่มีพบข้อมูลการสอบ Mock Exam! กรุณาเชื่อมระบบโรงเรียนก่อนนะ
    </Text>
    <Box p={SPACE.small} style={{ textAlign: 'center' }}>
      <Button primary circular onClick={onLinkSchoolClick}>
        <Icon name="school" iconStyle={{ verticalAlign: 'top' }} mr={SPACE.small} />
        เชื่อมระบบโรงเรียน
      </Button>
    </Box>
  </Flex>
);

export default EmptyView;
